import { parseJwt } from './parse-jwt'

// localStorage keys shared across auth-provider, axios interceptor and the
// "Viewing For" (admin impersonation) context.
export const TG_USER_DATA = 'tgUserData'
export const AD_USER_DATA = 'adUserData'
export const GOOGLE_TOKEN = 'googleToken'
export const AUTH_ME = 'authMe' // { role, investor_id, full_name, email }
export const VIEW_AS_INVESTOR = 'viewAsInvestor' // { id, name } chosen by an admin

export const getAuthMe = () => {
	try {
		return JSON.parse(localStorage.getItem(AUTH_ME)) || null
	} catch {
		return null
	}
}

export const isAdmin = () => getAuthMe()?.role === 'admin'

// A Google session is only valid while its id_token has not expired (Google
// issues ~1h tokens). A stale token must drop the session so the user re-logs in
// instead of getting stuck on a dead admin view.
export const isGoogleTokenValid = () => {
	const token = localStorage.getItem(GOOGLE_TOKEN)
	if (!token) return false
	try {
		const { exp } = parseJwt(token)
		return typeof exp === 'number' && Date.now() < exp * 1000
	} catch {
		return false
	}
}

export const clearGoogleSession = () => {
	localStorage.removeItem(GOOGLE_TOKEN)
	localStorage.removeItem(AUTH_ME)
	localStorage.removeItem(VIEW_AS_INVESTOR)
}

export const getViewAsInvestor = () => {
	try {
		return JSON.parse(localStorage.getItem(VIEW_AS_INVESTOR)) || null
	} catch {
		return null
	}
}
